import React, { useState } from 'react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: 'Immediatamente via email dopo il pagamento.'
}, {
  q: 'È adatto per le serie minori o solo giovanili?',
  a: 'Copre entrambi i settori con progressioni specifiche.'
}, {
  q: 'Posso stampare le schede?',
  a: "Certamente, sono ottimizzate per la stampa o l'uso da tablet."
}, {
  q: 'Funziona anche per chi allena da poco?',
  a: "Assolutamente sì. Il Kit è pensato sia per allenatori esperti che per chi è alle prime armi. Le programmazioni sono pronte all'uso e le progressioni sono spiegate passo dopo passo, così puoi seguirle anche senza anni di esperienza."
}, {
  q: 'Posso usare il materiale su più dispositivi?',
  a: 'Certo! Una volta acquistato, puoi accedere al materiale da qualsiasi dispositivo: computer, tablet o smartphone. I file sono in formato PDF, compatibili con tutti i dispositivi.'
}, {
  q: 'Come funziona la garanzia di 7 giorni?',
  a: "Se per qualsiasi motivo non sei soddisfatto del Kit, ti basta scriverci entro 7 giorni dall'acquisto e ti rimborseremo il 100% dell'importo, senza domande. Zero rischi per te."
}, {
  q: 'In quale formato ricevo gli esercizi e le programmazioni?',
  a: 'Tutto il materiale è in formato PDF di alta qualità, con schemi grafici chiari e pronti da consultare in palestra, da stampare o da visualizzare su tablet e smartphone.'
}, {
  q: 'Riceverò aggiornamenti futuri del Kit?',
  a: 'Sì, ogni aggiornamento del Kit ti sarà inviato automaticamente via email senza costi aggiuntivi. Il tuo acquisto è una tantum e include tutte le versioni future.'
}, {
  q: 'Quali metodi di pagamento posso utilizzare?',
  a: 'Accettiamo tutte le principali carte di credito e debito (Visa, Mastercard, American Express) oltre a PayPal. Il pagamento è sicuro, criptato ed elaborato tramite gateway certificati.'
}, {
  q: "C'è un servizio di assistenza in caso di dubbi?",
  a: 'Certo. Hai accesso al nostro supporto via email dedicato agli allenatori: rispondiamo entro 24 ore lavorative per qualsiasi dubbio sul materiale o sul suo utilizzo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-86">
      <div className="max-w-3xl mx-auto" data-id="element-87">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-88">
          Domande Frequenti
        </h2>

        <div className="space-y-4 mb-16" data-id="element-89">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(37,99,235,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-90">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-91">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-92">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-93">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-94">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-95">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-96">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(16,185,129,0.15) 0%, transparent 70%)'
        }} data-id="element-97"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-colors inline-block mb-4 w-full sm:w-auto max-w-2xl text-gray-900 shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-98">
            💪 SÌ! VOGLIO RIVOLUZIONARE I MIEI ALLENAMENTI ORA
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-99">
            <span data-id="element-100">⚡ Accesso Immediato</span>
            <span data-id="element-101">•</span>
            <span data-id="element-102">🛡️ Garanzia di 7 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}